import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import "./Testimonials.css";

import ganafarm from "../../assets/images/bannerGanafarm.png";
import homepagemekong from "../../assets/images/HomepageMekongZone.png";
import homepagemekongMobile from "../../assets/images/HomepageMekongZoneMobile.png";
import heroMobile from "../../assets/images/heroMobile.png";
import ganafarmMobile from "../../assets/images/homepageGanafarmMobile.png";
import markandmilk from "../../assets/images/HomepageMarkandmilk.png";
import markandmilkMobile from "../../assets/images/homepageMarkandmilkMobile.png";
import mekongcocoa from "../../assets/images/HomepageMekongCocoa.png";
import mekongcocoaMobile from "../../assets/images/homepageMekongMobile.png";
import henk from "../../assets/images/HomepageHenk.png";
import henkMobile from "../../assets/images/homepageHenkMobile.png";
import store from "../../assets/images/Store.png";
import hero from "../../assets/images/hero.png";
import { Link } from "react-router-dom";

const slideData = [
  {
    className: "homepage-hero",
    image: hero,
    imgMobile: heroMobile,
  },
  {
    className: "homepage-mekong",
    image: homepagemekong,
    title1: "PACKING VIETNAMESE",
    title2: "HEART & SOUL",
    desc: "about_mekong_desc",
    subtitle: "MEKONG ZONE - THE TASTE OF DISCOVERY",
    button: false,
    imgMobile: homepagemekongMobile,
  },
  {
    className: "ganafarm homepage__banner",
    image: ganafarm,
    title1: "CREATING JOY!",
    desc: "desc_ganafarm_detail",
    button: true,
    imgMobile: ganafarmMobile,
    shopnow: "ganafarm"
  },
  {
    className: "mark-and-milk homepage__banner",
    image: markandmilk,
    title1: "PICK ME UP",
    desc: "desc_markandmilk_detail",
    button: true,
    imgMobile: markandmilkMobile,
    shopnow: "mark-and-milk"
  },
  {
    className: "henk homepage__banner",
    image: henk,
    title1: "EVERY PIECE IS A PRESENT",
    desc: "desc_henk_detail",
    button: true,
    imgMobile: henkMobile,
    shopnow: "henk"
  },
  {
    className: "mekong-cocoa homepage__banner",
    image: mekongcocoa,
    title1: "AUTHENTIC BEAN-TO-BAR",
    desc: "desc_mekongcocoa_detail",
    button: true,
    imgMobile: mekongcocoaMobile,
    shopnow: "mekong-cocoa"
  },
];

const Testimonials = () => {
  const { t, i18n } = useTranslation(); // Thêm useTranslation
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767
      );
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const settings = {
    infinite: true,
    autoplay: true,
    speed: 2000,
    swipToSlide: true,
    // autoplaySpeed: 3000,
    slidesToShow: 1,
    arrow: true,
    dots: true,
  };

  console.log(slideData.className);
  

  return (
    <Slider {...settings}>
      {isMobile
        ? slideData.map((item, index) => (
            <div className={`testimonials ${item.className}`} key={index}>
              <div className="banner">
                <div className="m-0">
                  <img src={item.imgMobile} alt="" className="hero" />
                  <div className="content">
                    <div className="store">
                      <img src={store} alt="" />
                    </div>
                    <div className="description">
                      <div className="desc__detail">
                        <div className="title">{t(item.title1)}</div>
                        {item.title2 && (
                          <div className="title">{item.title2}</div>
                        )}
                        <div className="desc">{t(item.desc)}</div>
                        {item.subtitle && (
                          <div className="sub-title">{t(item.subtitle)}</div>
                        )}
                        {item.button && (
                          <Link to={`/san-pham/${item.shopnow}`}>
                            <button className="purchase">
                              {t("shop_now")}
                            </button>
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        : slideData.map((item, index) => (
            <div className={`testimonials ${item.className}`} key={index}>
              <div className="banner">
                <div className="m-0">
                  <img src={item.image} alt="" className="hero" />
                  <div className="content">
                    <div className="store">
                      <img src={store} alt="" />
                    </div>
                    <div className="description">
                      <div className="desc__detail">
                        <div className="title">{t(item.title1)}</div>
                        {item.title2 && (
                          <div className="title">{item.title2}</div>
                        )}
                        <div className="desc">{t(item.desc)}</div>
                        {item.subtitle && (
                          <div className="sub-title">{t(item.subtitle)}</div>
                        )}
                        {item.button && (
                          <Link to={`/san-pham/${item.shopnow}`}>
                            <button className="purchase">
                              {t("shop_now")}
                            </button>
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
    </Slider>
  );
};

export default Testimonials;
